import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { ResponsiveService, ResponsiveFormat } from "./responsive.service";
import { createLocalStore } from "@/_services/storage";

const SidebarStorage = createLocalStore<"expanded" | "collapsed">(
    "sidebar-state",
);

@Injectable({ providedIn: "root" })
export class SidebarStateService implements OnDestroy {
    private _isCollapsed$ = new BehaviorSubject<boolean>(false);
    isCollapsed$ = this._isCollapsed$.asObservable();

    private subscription: Subscription;

    get isCollapsed(): boolean {
        return this._isCollapsed$.value;
    }

    constructor(private responsiveService: ResponsiveService) {
        this.applyBreakpoint(this.responsiveService.responsiveFormat);

        this.subscription =
            this.responsiveService.responsiveChangeSubject.subscribe((format) =>
                this.applyBreakpoint(format),
            );
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

    toggle() {
        const newCollapsed = !this.isCollapsed;
        this._setCollapsed(newCollapsed);
        if (this.responsiveService.responsiveFormat === "DESKTOP") {
            SidebarStorage.put(newCollapsed ? "collapsed" : "expanded");
        }
    }

    private applyBreakpoint(format: ResponsiveFormat) {
        if (format === "TABLET") {
            this._setCollapsed(true);
        } else if (format === "DESKTOP") {
            const saved = SidebarStorage.get();
            this._setCollapsed(saved === "collapsed");
        }
        // MOBILE: sidebar hidden by directive; state doesn't matter
    }

    private _setCollapsed(collapsed: boolean) {
        this._isCollapsed$.next(collapsed);
        document.body.style.setProperty(
            "--current-sidebar-width",
            collapsed ? "80px" : "250px",
        );
    }
}
